import { Clipboard } from '@angular/cdk/clipboard';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { constObj } from '../../common/Constants/constants';
import { HttpcallService } from '../../common/services/httpcall.service';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-my-bookmark',
  templateUrl: './my-bookmark.component.html',
  styleUrls: ['./my-bookmark.component.css']
})
export class MyBookmarkComponent implements OnInit, AfterViewInit {
  public displayedColumns = ['Title', 'ParagraphId', 'Dateadded', 'Action'];
  public dataSourceCod = new MatTableDataSource<myBookmarks>();
  public dataSourceOP = new MatTableDataSource<myBookmarks>();
  public dataSourceCIG = new MatTableDataSource<myBookmarks>();
  res: myBookmarks[];
  paragraphId: string = "";
  currentRoute: string;

  @ViewChild('TableOnePaginator', { static: true }) paginatorCod: MatPaginator;
  @ViewChild('TableTwoPaginator', { static: true }) paginatorOP: MatPaginator;
  @ViewChild('TableThreePaginator', { static: true }) paginatorCIG: MatPaginator;
  userId: string;
  mailId: string;
  IsBookmark: boolean;
  bookmarkmaintile: any;// ="My Bookmarks";
  titleheadername: any;// ="Title";
  bookmarkheadername: any;// ="Bookmark";
  dateheadername: any;//= "Date added";
  pagesize: any = 10;
  //actualresult: { ID: string; CreateUserId: string; TopicId: string; ParagraphId: string; BookmarkTitle: string; BookMarkBreadCrumb: string; IsDeleted: boolean; CreatedOn: string; ModifiedOn: string; ApplicationSource: string; BookmarkURL: string;}[];
  actualresult: any;
  pagelistarrayCod: any[] = [];
  pagelistarrayOP: any[] = [];
  pagelistarrayCIG: any[] = [];
  accordionRows: any[] = [];
    leftNavmenuLevel = [1, 2, 3]
    noRecords = constObj.Norecords;
  constructor(private httpCallService: HttpcallService, private route: Router, private session: SessionService,
    public commonDataService: CommonDataService, private loginService: LoginService, private clipboard: Clipboard, private router: Router, private graphQlService: GraphqlService) { }
  @ViewChild('TableOneSort', { static: true }) sortCod: MatSort;
  @ViewChild('TableTwoSort', { static: true }) sortOP: MatSort;
  @ViewChild('TableThreeSort', { static: true }) sortCIG: MatSort;
  ngOnInit() {
    this.getUserId();
    this.getmybookmarkLabel();
  }


  public redirectToDetails = (id: string) => {

  }
  getmybookmarkLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.bookmarkmaintile = labels.filter(x => x.key == "myBookmarks_header").map(y => y.value);
        this.titleheadername = labels.filter(x => x.key == "myBookmarks_columnOne").map(y => y.value);
        this.bookmarkheadername = labels.filter(x => x.key == "myBookmarks_columnTwo").map(y => y.value);
        this.dateheadername = labels.filter(x => x.key == "myBookmarks_columnThree").map(y => y.value);

        //this.commonDataService.showLoader.next(false);
      }
    });
  }
  public copyToClipboard = (URL: string, Title: string, location1: string[], ParagraphId: string) => {
    let span = document.createElement('span');
    span.innerHTML = location1.join(' -> ').split("____")[0];
    let BreadcrumbLocation = span.innerText.trim().replace(/\s+/g, " ");
    this.clipboard.copy("Bookmark: " + Title + "\nLink: " + location.origin + URL + "\nLocation: " + BreadcrumbLocation);
    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }

  public redirectToDelete = (id: string) => {
    this.commonDataService.showLoader.next(true);
    var bookmarkarray = this.actualresult.filter(x => x.id == id)[0];
    var bookmark = {
      ID: bookmarkarray.id, TopicId: bookmarkarray.topicId, ParagraphId: bookmarkarray.paragraphId, BookmarkTitle: bookmarkarray.bookmarkTitle, BookMarkBreadCrumb: bookmarkarray.bookMarkBreadCrumb, IsDeleted: true, CreatedOn: bookmarkarray.createdOn, ModifiedOn: bookmarkarray.modifiedOn, ApplicationSource: bookmarkarray.applicationSource,
      BookmarkURL: bookmarkarray.bookmarkURL + "/" + bookmarkarray.paragraphId, NavigationPath: bookmarkarray.navigationPath
    }
    this.httpCallService.addUpdateBookmark(bookmark).toPromise()
      .then(response => {
        //this.closeOverlay();
        this.commonDataService.showLoader.next(false);
        let obj = {
          type: 'success',
          displayTime: 5000,
          position: 'bottom',
          message: constObj.bookmarkRemovedMessage
        }
        this.commonDataService.notificationObject.next(obj);
        this.getBookmarkdata();
      })
      .catch(console.log);
  }
  ngAfterViewInit(): void {
    this.dataSourceCod.sort = this.sortCod;
    this.dataSourceCod.paginator = this.paginatorCod;
    this.dataSourceOP.sort = this.sortOP;
    this.dataSourceOP.paginator = this.paginatorOP;
    this.dataSourceCIG.sort = this.sortCIG;
    this.dataSourceCIG.paginator = this.paginatorCIG;

  }
  getBookmarkdata() {
      this.accordionRows = ["Codification", "Original Pronouncements", "Comprehensive Implementation Guide"];//data1.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item)
    this.httpCallService.getMyBookmark(this.paragraphId).subscribe((resp: any) => {
        this.actualresult = resp;
        this.IsBookmark = resp.length > 0 ? true : false;
        var ress = this.actualresult.map(x => ({ id: x.id, Title: x.bookmarkTitle, Bookmark: x.bookMarkBreadCrumb.split("~"), Dateadded: new Date(x.createdOn), ParagraphId: x.paragraphId, BookmarkURL: x.bookmarkURL, LeftNavOrigin: x.bookMarkBreadCrumb.split("~")[0] }))
        //this.accordionRows = ress.map(x => x.LeftNavOrigin).filter((value, index, self) => self.indexOf(value) === 
        for (let item of this.accordionRows) {
          var data: any;
          if (item == "Original Pronouncements" || item == "Comprehensive Implementation Guide") {
            data = ress.filter(x => x.LeftNavOrigin == item);
          } else {
            data = ress.filter(x => (x.LeftNavOrigin != "Original Pronouncements") && (x.LeftNavOrigin != "Comprehensive Implementation Guide"));
          }
          if (item == "Codification") {
            this.dataSourceCod.data = data as myBookmarks[];
            this.pagelistarrayCod = []
            for (let i = 10; i <= data.length + 10; i = i + 10) {
              this.pagelistarrayCod.push(i);
            }
          }
          else if (item == "Original Pronouncements") {
            this.dataSourceOP.data = data as myBookmarks[];
            this.pagelistarrayOP = []
            for (let i = 10; i <= data.length + 10; i = i + 10) {
              this.pagelistarrayOP.push(i);
            }
          }
          else if (item == "Comprehensive Implementation Guide") {
            this.dataSourceCIG.data = data as myBookmarks[];
            this.pagelistarrayCIG = []
            for (let i = 10; i <= data.length + 10; i = i + 10) {
              this.pagelistarrayCIG.push(i);
            }
          }
        }
        this.commonDataService.showLoader.next(false);
      })
  }
  getUserId() {
    //this.getBookmarkdata();
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.commonDataService.userId.next(data.user.userName);
        this.commonDataService.mailId.next(data.user.email);
        this.userId = data.user.userName;
        this.mailId = data.user.email;
        this.getBookmarkdata();
      })
    }
    else {
      this.userId = this.session.userInfo.user.userName;
      this.mailId = this.session.userInfo.user.email;
      this.getBookmarkdata();
    }


  }
  NavigateTo(url, id) {
    if ((!url?.startsWith("/") && url?.split("/").length < 3) || (url?.startsWith("/") && url?.split("/").length <= 3)) {
      url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + id;
    }
    this.route.navigateByUrl(url);
  }
}

export interface myBookmarks {
  id: string
  Title: string;
  Bookmark: string;
  Dateadded: Date;
  ParagraphId: string;
  BookmarkURL: string;
  LeftNavOrigin: string;
}


